type MessageActionButtonsProps = {
  actions: string[];
  onAction?: (action: string) => void;
};

export default function MessageActionButtons({
  actions,
  onAction,
}: MessageActionButtonsProps) {
  if (actions.length === 0) return null;

  return (
    <div className="mt-3 flex flex-wrap gap-2">
      {actions.map((action) => (
        <button
          key={action}
          onClick={() => onAction?.(action)}
          className="rounded-lg border border-blue-200 bg-blue-50 px-3 py-1.5 text-xs font-medium text-blue-700 transition-colors hover:bg-blue-100"
        >
          {action}
        </button>
      ))}
    </div>
  );
}
